import React from 'react';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

interface ICaretProps {
  className?: string;
}
const CaretIconInner: React.FC<ICaretProps> = ({ className }) => (
  <svg className={className} width='8' height='15' viewBox='0 0 8 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.782591 5.75H7.21509C7.66009 5.75 7.88259 6.33789 7.56759 6.68242L4.35259 10.2016C4.15759 10.4148 3.84009 10.4148 3.64509 10.2016L0.430091 6.68242C0.115091 6.33789 0.337591 5.75 0.782591 5.75Z'
      fill={Colors.GRAY_DARK_30}
    />
  </svg>
);

export const CaretIcon = styled(CaretIconInner)`
  margin: 0 0 2px 5px;
`;
